module.exports = __webpack_public_path__ + "static/pattern-widget-table-e7e6d934cdfcac9d4e635bf6a1739f15.png";